/**
 * Query keys shared across layers.
 *
 * These live outside any feature so low-level code (the axios
 * interceptors) can invalidate them without importing a feature module —
 * which would create a cycle, since features import the axios client.
 */

/** The customer's entitled modules — what the station rail renders from. */
export const PORTAL_MODULES_KEY = ["portal", "modules"] as const
